import React from 'react';
import TagManagementTrendKeywordNavbar from '../TagManagementTrendKeywordNavbar';
import TagManagementTrendKeywordTopRankList from '../TagManagementTrendKeywordTopRankList';
import TagManagementTrendKeywordStyleList from '../TagManagementTrendKeywordStyleList';
import TagManagementTrendKeywordCollectionList from '../TagManagementTrendKeywordCollectionList';
import { TAG_TREND_KEYWORD_SECTION_TYPE } from '../../../../../constants/service/app/tagConstants';
import './TagManagementTrendKeywordWrap.scss';

const TagManagementTrendKeywordWrap = (props) => {
  const {
    tagTrendKeyword,
    onSubmit,
    getTagTrendKeywordContentsList,
    selectTrendKeywordMainContentsList,
    onDragEndSelectTagTrendKeywordContentsList,
    tagTrendKeywordPreview,
    getRelatedTagList,
    getTagTrendKeywordAllListExcelDownload,
    getTagTrendKeywordSelectedListExcelDownload,
    setTagTrendKeywordExcelUpload,
  } = props;

  return (
    <div className="tag-management-trend-keyword-wrap">
      {/* 하단 네브바 */}
      <TagManagementTrendKeywordNavbar tagTrendKeywordPreview={tagTrendKeywordPreview} />

      {/* top 30 추천 태그 리스트 */}
      <TagManagementTrendKeywordTopRankList
        onSubmit={onSubmit}
        recommendTagTopRankList={tagTrendKeyword[TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_TOP_RANK_LIST]}
        getTagTrendKeywordContentsList={getTagTrendKeywordContentsList}
        selectTrendKeywordMainContentsList={selectTrendKeywordMainContentsList}
        onDragEndSelectTagTrendKeywordContentsList={onDragEndSelectTagTrendKeywordContentsList}
        getRelatedTagList={getRelatedTagList}
        getTagTrendKeywordAllListExcelDownload={getTagTrendKeywordAllListExcelDownload}
        getTagTrendKeywordSelectedListExcelDownload={getTagTrendKeywordSelectedListExcelDownload}
        setTagTrendKeywordExcelUpload={setTagTrendKeywordExcelUpload}
      />

      {/* 스타일별 추천 태그 리스트 */}
      <TagManagementTrendKeywordStyleList
        onSubmit={onSubmit}
        recommendTagStyleList={tagTrendKeyword[TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_STYLE_LIST]}
        getTagTrendKeywordContentsList={getTagTrendKeywordContentsList}
        selectTrendKeywordMainContentsList={selectTrendKeywordMainContentsList}
        onDragEndSelectTagTrendKeywordContentsList={onDragEndSelectTagTrendKeywordContentsList}
        getRelatedTagList={getRelatedTagList}
        getTagTrendKeywordAllListExcelDownload={getTagTrendKeywordAllListExcelDownload}
        getTagTrendKeywordSelectedListExcelDownload={getTagTrendKeywordSelectedListExcelDownload}
        setTagTrendKeywordExcelUpload={setTagTrendKeywordExcelUpload}
      />

      {/* 태그 모아보기 추천 태그 리스트 */}
      <TagManagementTrendKeywordCollectionList
        onSubmit={onSubmit}
        recommendTagCollectionList={tagTrendKeyword[TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_COLLECTION_LIST]}
        getTagTrendKeywordContentsList={getTagTrendKeywordContentsList}
        selectTrendKeywordMainContentsList={selectTrendKeywordMainContentsList}
        onDragEndSelectTagTrendKeywordContentsList={onDragEndSelectTagTrendKeywordContentsList}
        getRelatedTagList={getRelatedTagList}
        getTagTrendKeywordAllListExcelDownload={getTagTrendKeywordAllListExcelDownload}
        getTagTrendKeywordSelectedListExcelDownload={getTagTrendKeywordSelectedListExcelDownload}
        setTagTrendKeywordExcelUpload={setTagTrendKeywordExcelUpload}
      />
    </div>
  );
};

export default TagManagementTrendKeywordWrap;
